import { render, staticRenderFns } from "./test-portal-notification-list.vue?vue&type=template&id=39cd056a&"
import script from "./test-portal-notification-list.vue?vue&type=script&lang=js&"
export * from "./test-portal-notification-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "test-portal-notification-list.vue"
export default component.exports